import React from "react";
import {NavLink} from 'react-router-dom'
import axios from 'axios';
import OrderListItem from "./OrderListItem"
import {whereBallsMove, getHeader} from "../../helper"
import LeftNavContent from "../Commons/LeftNavContent";
import BuyPackModal from "./BuyPackModal";

import { connect } from 'react-redux';
import { getProducts, getMoreProducts, buyPack, addPackLike, addPackDislike } from '../../actions/buyActions.js';
import { getEmployees } from '../../actions/employeesActions';
import { getCompanies, writeOffMoneyCompany } from '../../actions/companyActions'
import { writeOffMoneyUser } from "../../actions/session";
import { fetchInfo } from "../../actions/index";
import FilterPane from "./FilterPane";
import { SetUrlBuild } from "../Commons/SetUrlBuild";

class BuyReady extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            searchValue: '',
            company: null,

            buyModal: {
                show: false,
                type: "default",
                pack: {},
            },

            autocompleteData: {
                results: []
            },

            filters: {
                q: '',
                order_id: '',
                object_id: null,
                object_value: '',
                orderposition__order_method_type_id: '',
                order_by: '-created_at',
            }
        }
    }

    componentWillMount() {
        const {params} = this.props.match;
        const {id} = params;
        let newParam = id || '';

        if(newParam.search(/^[0-9]*$/) < 0) {
            newParam = '';
            this.props.history.push("/buy");
        }

        const ff = new URLSearchParams(window.location.search.substring(1));

        this.setState({
            filters: {
                ...this.state.filters,
                q: ff.get('q') || '',
                order_id: ff.get('order_id') || '',
                object_id: ff.get('object_id') || null,
                object_value: ff.get('object_value') || '',
                orderposition__order_method_type_id: ff.get('orderposition__order_method_type_id') ||  '',
                order_by: ff.get('order_by') || '-created_at',
            }
        }, () => {
            this.getProductList({my: newParam})
        });

        this.props.dispatch(
            fetchInfo([{
                query: 'order_method_type'
            }])
        );
        
    }

    componentWillReceiveProps(nextProps) {
        const { id } = this.props.match.params;
        const nextParams = nextProps.match.params;

        if(id !== nextParams.id){
            this.getProductList({my: nextParams.id || ''})
        }
    }

    getProductList(uriParam) {
        const {session:{isLoggedIn}} = this.props;
        let headers = isLoggedIn ? {headers:getHeader()} : {};
        const {filters} = this.state;
        let params = {...filters, ...uriParam};
        delete params.object_value;
        if(params.orderposition__order_method_type_id === "0") {
            delete params.orderposition__order_method_type_id;
        }
        this.props.dispatch(getProducts(params, headers))
    }

    componentDidMount() {
        document.title = 'Fixfact';
        whereBallsMove(8);

        this.props.dispatch(fetchInfo([
            {
                query: 'settings',
                params: {},
            }
        ]));
    }

    handleSubmit() {
        let id = this.props.match.params.id;
        SetUrlBuild(this.state.filters);

        this.getProductList({my: id || ''});
        this.setState({
            isOpen: false
        })
    }

    onBuyClick(pack) {
        const { dispatch, session, data:{settings} } = this.props;
        const { buy_tax_percent } = settings;
        let comission = 0;
        let totalPrice = parseFloat(pack.price);

        if(buy_tax_percent) {
            comission = pack.price * buy_tax_percent / 100;
            totalPrice = (parseFloat(pack.price) + parseFloat(comission))
        }
        
        dispatch(getCompanies({ user_id: session.currentUser.id }, session.token));

        this.setState({
            buyModal: {
                ...this.state.buyModal,
                show: true,
                pack,
                comission,
                totalPrice,
            },
        })
    }

    onBuyConfirm() {
        const {pack, totalPrice} = this.state.buyModal;
        let headers = {headers:getHeader()};
        const {company} = this.state;

        if(!pack.id) return false;

        let paymentData = {
            price: totalPrice
        };
        
        if (company && company.value > 0) {
            paymentData.company_id = company.value;
        }

        this.props.dispatch(
            buyPack(
                {id: pack.id, ...paymentData},
                (response) => {
                    this.setState({
                        buyModal: {
                            ...this.state.buyModal,
                            type: "success",
                            text: "Покупка завершена!"
                        }
                    })
                    this.props.dispatch(getProducts(this.state.filters.q, headers));
                    this.writeOffMoney(paymentData)
                },
                (errors) => {
                    this.setState({
                        buyModal: {
                            ...this.state.buyModal,
                            type: "error",
                            text: "Ошибка!"
                        }
                    })
                }
            )
        )
    }

    writeOffMoney(paymentData) {
        let isCompany = (!paymentData.company_id || parseInt(paymentData.company_id) === 0) ? false : true;

        if (isCompany) {
            this.props.dispatch(writeOffMoneyCompany(paymentData))
        }
        else {
            this.props.dispatch(writeOffMoneyUser(paymentData))
        }
    }

    onBuyCancel() {
        this.setState({
            buyModal: {
                ...this.state.buyModal,
                show: false,
                type: 'default',
                pack: {}
            },
        })
    }

    handleSelectCompany(company) {
        let { dispatch, employees:{data}, session:{currentUser} } = this.props;

        if (!company || (this.state.company && company.value === this.state.company.value)) {
            return false;
        }

        if(company.value > 0) {
            let currentCompany = data.results.filter(item => item.company_id === company.value);
            if(!currentCompany.length) {
                dispatch(
                    getEmployees({company_id: company.value, user_id:currentUser.id})
                );
            }
        }

        this.setState({
            company,
        })
    }

    handleMoreOrders(next) {
        const {session:{isLoggedIn}} = this.props;
        let id = this.props.match.params.id;
        this.setState({
            isOpen: false
        });

        let headers = isLoggedIn ? {headers:getHeader()} : {};
 
        const {filters} = this.state;
        let params = {...filters, my: id || ''};
        delete params.object_value;
        if(params.orderposition__order_method_type_id === "0") {
            delete params.orderposition__order_method_type_id;
        }
        this.props.dispatch(getMoreProducts(next, params, headers))
    }

    handleLike(pack) {
        this.props.dispatch(addPackLike(pack));
    }

    handleDislike(pack) {
        this.props.dispatch(addPackDislike(pack));
    }

    handleInput(e) {
        this.setState({
            filters: {
                ...this.state.filters,
                [e.name]: e.value
            }
        })
    }

    handleObject(value) {
        if(value.search(/[0-9]/) >= 0) return false;

        this.setState({
            filters: {
                ...this.state.filters,
              //  object_id: value,
                object_value: value,
            }
        });

        if (!value.trim()) {
            this.setState({
                autocompleteData:{results:[]}
            })
            return false;
        }

        axios.get(`${window.siteUrl}/api/v1/order_object/`, {
            params: {
                q: value,
            },
            headers: getHeader()
        }).then(response => {
            let length = value.trim().length;
            let checkingRes = [];

            if(length) {
                checkingRes = response.data.results.filter(item =>
                    (item.title).toLowerCase() == (value).toLowerCase()
                );
            }

            this.setState({
                filters: {
                    ...this.state.filters,
                    object_id: checkingRes.length ? checkingRes[0].id : null,
                    object_value: checkingRes.length ? checkingRes[0].title : value,
                },
                autocompleteData: Object.assign({}, this.state.autocompleteData, {
                    ...response.data
                })
            })
        }).catch(error => {
            console.error(" error", error);
        });
    }

    handleObjectSelect(item) {
        this.setState({
            filters: {
                ...this.state.filters,
                object_id: item.id,
                object_value: item.title,
            }
        })
    }

    resetFilters(e) {
        e.preventDefault();
      //  window.history.pushState(null, null, "/");

        this.setState({
            filters: {
                q: '',
                order_id: '',
                object_id: null,
                object_value: '',
                orderposition__order_method_type_id: '',
                order_by: '-created_at',
            }
        })
    }

    render() {
        const {products, session, employees, data:{order_method_type}, match:{params}} = this.props;
        const {isOpen, filters} = this.state;
        const isFetching = products.isFetching;
        const packs = products.data;

        let options = [{ value: 0, label: 'Выберите компанию' }];
        this.props.company.companies.data.results.map((item, index) => {
            options.push({
                value: item.id,
                label: item.title,
            })
        });

        const {isFetchingMore} = packs;

        return(
            <div className="vertical-scrolling page eighthSection sectionBuyReady" id="sectionBuyReady" data-main-nav-id="buyReadyNavLink">
                <div className="container content">

                    <BuyPackModal
                        inputProps={this.state.buyModal}
                        onConfirm={() => this.onBuyConfirm()}
                        onCancel={() => this.onBuyCancel()}
                        selectCompany={(company) => this.handleSelectCompany(company)}
                        companies={options}
                        company={this.state.company}
                        currentUser={session.currentUser}
                        currentEmployee={employees.data.results}
                    />

                    <LeftNavContent>
                        <h2 className="left-content__title">
                            <span className="text_gradient_violet_circle disabled" style={{marginRight: "20px"}}>Публикации</span>
                        </h2>

                        <ul className="menu-content-nav">
                            <NavLink exact to="/buy/"> Все</NavLink>
                            <NavLink to="/buy/1"> Мои покупки</NavLink>
                            <NavLink to="/buy/2"> Мои продажи</NavLink>
                            <NavLink to="/buy/3"> Покупки юр. лица</NavLink>
                        </ul>
                    </LeftNavContent>
    
                    <div className="right-content native-scroll right-content-bottom right-content-width">
                        <div className="screen-outer-block-wrap native-scroll menu-content">

                            <div className="rounded-white-block screen-bottom-block">
                                <div className="white-block-top search-top-panel header-tabs tab-nav">
                                    <button onClick={this.handleSubmit.bind(this)} className="big-search-button"></button>
                                    <input 
                                        type="text" 
                                        className="big-search-input"
                                        name="q"
                                        placeholder="Поиск"
                                        value={filters.q}
                                        onChange={(e) => this.handleInput(e.target)}
                                        onKeyPress={(e) => { if(e.key === 'Enter') this.handleSubmit()}}/>

                                    <a href=""
                                        className="big-search-detail-link"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.setState({isOpen: !isOpen})
                                        }}
                                        >{isOpen ? 'Закрыть' : 'Подробнее'}
                                    </a>
                                </div>

                                <FilterPane
                                    isOpen={isOpen}
                                    filters={filters}
                                    handleSubmit={() => this.handleSubmit()}
                                    resetFilters={(e) => this.resetFilters(e)}
                                    handleInput={(value, field) => this.handleInput(value, field)}
                                    orderMethodType={order_method_type}
                                    autocompleteData={this.state.autocompleteData}
                                    handleObject={(value) => this.handleObject(value)}
                                    handleObjectSelect={(item) => this.handleObjectSelect(item)}
                                />
    
                                <div className="white-block-content">
                                    <ul className="search-list items-list ready-orders">
                                        {
                                            isFetching ?
                                            <div style={{padding:'30px 20px 10px 20px'}}>Загружается...</div>
                                            :
                                            packs.results.map(pack => (
                                                <OrderListItem 
                                                    key={pack.id} 
                                                    item={pack}
                                                    onBuyClick={this.onBuyClick.bind(this)}
                                                    session={session}
                                                    handleLike={(elem) => this.handleLike(elem)}
                                                    handleDislike={(elem) => this.handleDislike(elem)}/>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>

                            {
                                packs.next && !isFetching ?
                                <div
                                    className="big-button button-action"
                                    style={{ height: "auto", textAlign: "center", marginTop: "30px", marginBottom: "30px" }}>
                                    <button
                                        className={isFetchingMore ? 'disabled btn-more' : 'btn-more'}
                                        onClick={() => this.handleMoreOrders(packs.next)}>
                                        {isFetchingMore ? 'Загружается...' : 'Загрузить еще'}
                                    </button>
                                </div>
                                : null
                            }
                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    ...state
}))(BuyReady);


// WEBPACK FOOTER //
// ./src/components/BuyReady/index.js